import React from "react";
import ReactDOM from "react-dom";
import SearchResults from "./components/SearchResults";
import "./scripts.js";
import * as Sentry from "@sentry/react";
const MIX_SENTRY_LARAVEL_DSN = process.env.MIX_SENTRY_LARAVEL_DSN;
Sentry.init({
  dsn: MIX_SENTRY_LARAVEL_DSN
});

const rootElement = document.getElementById("root");
const favourite = rootElement.getAttribute('data-favourite');
ReactDOM.render(<SearchResults favourite={favourite}/>, rootElement);